import { authApi } from "shared/api/authApi";

export const registrationRequest = (payload) => {
  return authApi.register(payload);
};
